import {Component, Injector} from '@angular/core';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {TasksReportsApiService} from '../../../../../Services/Api/Reports/Tasks/tasks-reports-api.service';
import {TasksReportFilters} from '../../../../../Models/Reports/Tasks/Shared/tasks-report-filters.model';
import {ChecklistReportDto} from '../../../../../Models/Reports/Tasks/Checklists/checklists-report.interface';

@Component({
  selector: 'app-completed-checklists-widget',
  templateUrl: './completed-checklists-widget.component.html',
  styleUrls: ['./completed-checklists-widget.component.scss'],
  standalone: false
})
export class CompletedChecklistsWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 28;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected tasksReportsService: TasksReportsApiService,
  ) {
    super(injector, tasksReportsService);
  }


  /**
   * Obtener el porcentaje de checklist completados
   *
   */
  override setData(data: ChecklistReportDto) {
    this.data = data ? Math.round(data.porcentaje_global.base) : 0;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: TasksReportFilters = new TasksReportFilters();

    if (this.widgetsManager.filters) {
      filters.id_local = this.widgetsManager.filters.local?.id ? [this.widgetsManager.filters.local.id] : [];
      filters.fecha_inicio = this.widgetsManager.filters.fecha_inicio || filters.fecha_inicio;
      filters.fecha_fin = this.widgetsManager.filters.fecha_fin || filters.fecha_fin;
    }

    return this.tasksReportsService.getChecklistsReport(filters);
  }

}
